// @ts-nocheck
import { types, flow, getRoot, Instance, SnapshotOut } from 'mobx-state-tree';
import { getBaseStore } from './BaseStore';
import { getEnvironment } from './utils';
import { Page } from '../common/enums';
import { RootStore } from './RootStore';
import { PharmacyNeighbor } from './models/PharmacyNeighbor';
import { PharmacyDetails } from './models/PharmacyDetails';
import { PharmacyViews } from './PharmacyStore';

export const CalendarChange = types.model({
  newBlackPoints: types.array(types.string),
  newBlackPointsEconomic: types.array(types.string),
  newBlackPointsHealth: types.array(types.string),
  newDayDuties: types.array(types.string),
  newDayNightDuties: types.array(types.string),
  deletedDutyOffRequests: types.array(types.string),
  deletedBlackPoints: types.array(types.string),
  deletedBlackPointsEconomic: types.array(types.string),
  deletedBlackPointsHealth: types.array(types.string),
  deletedDayDuties: types.array(types.string),
  deletedDayNightDuties: types.array(types.string),
  deletedNightDuties: types.array(types.string),
  comment: types.string,
  pharmacyId: types.number,
});

export const PharmacyDetailedStore = types
  .compose(
    getBaseStore<Instance<typeof PharmacyDetails>, SnapshotOut<typeof PharmacyDetails>>(
      PharmacyDetails,
      'pharmacyId',
      'pharmacy',
      { view: 'DETAILED' },
    ),
    types.model('PharmacyDetailedStore', {}),
  )
  .views((self) => ({
    getByIdOrNew(id: number) {
      if (id > 0) {
        return self.datas.get(id.toString());
      } else {
        return {
          pharmacyId: undefined,
          isContributing: true,
          isActive: true,
          receivesSms: true,
        };
      }
    },
  }))
  .actions((self) => {
    const env = getEnvironment(self);
    const apiFetcher = env.api;
    const root: Instance<typeof RootStore> = getRoot(self);

    const savePharmacyDetails = flow(function*(pharmacyDetails: Instance<typeof PharmacyDetails>) {
      const res = yield self.saveElement(pharmacyDetails);
      if (pharmacyDetails.pharmacyId !== res.pharmacyId) {
        root.ApplicationStore.navigate(`${Page.Pharmacies}/${res.pharmacyId}`);
      }
    });

    const registerMembers = flow(function*(members: Array<Instance<typeof PharmacyDetails>>, group: string) {
      const res = yield env.api.put('pharmacy/registerGroup/' + group, members);
    });

    const unregisterMembers = flow(function*(members: Array<Instance<typeof PharmacyDetails>>) {
      const res = yield env.api.put('pharmacy/unregisterGroup', members);
    });

    const updatePharmacyGeoData = flow(function*(pharmacyDetails: number) {
      console.log(pharmacyDetails);
      const res = yield env.api.post('pharmacy/refreshGeoData/' + pharmacyDetails, null);
    });

    const loadNeighboringPharmacies = flow(function*(pharmacyId: number) {
      const callResult = yield self.loadElement(pharmacyId);
      const array = [...callResult.pharmacyNeighbors];
      const resultSorted = array.sort((a, b) => a.distance - b.distance);
      const finalResult = resultSorted.map((item: Instance<typeof PharmacyNeighbor>) => {
        var pharm = root.PharmacyStore.getById(item.neighborId);
        pharm.distance = item.distance;
        return pharm;
      });
      return finalResult;
    });

    const loadGroupPharmacies = flow(function*(pharmacyId: number) {
      const group1 = yield apiFetcher.get(`pharmacy/${pharmacyId}/group`, {
        params: {
          view: 'DETAILED',
        },
      });
      const group = group1.filter((item) => item.pharmacyId !== pharmacyId);
      const callResult = yield self.loadElement(pharmacyId);
      const array = callResult.pharmacyNeighbors;
      // const resultSorted = array.sort((a, b) => a.distance - b.distance);
      // const finalResult = resultSorted.map((item: Instance<typeof Pharmacy>) => {
      //    var pharm = root.PharmacyNeighbor.getById(pharmacyId);
      //    pharm.distance = item.distance;
      //   return pharm;
      // });
      // return finalResult;

      //modifier ci-dessous pour obtenir les distance via TomTom ou Google Maps
      const list = group.map((member) => {
        // const phn = array.find(m => m.neighborId === member.pharmacyId);
        member.distance = member.drivingDistance; //phn?phn.distance:999999;
        return member;
      });

      const sortedResult = list.sort((a, b) => a.distance - b.distance);
      return sortedResult;
    });

    const getMissingHolidays = flow(function*(criteria) {
      console.log(criteria);
      const result = yield apiFetcher.get('blackpoint/checkMissingHolidays', {
        params: criteria,
      });
      return result;
    });

    const saveCalendarChange = flow(function*(calendarChange: Instance<typeof CalendarChange>) {
      yield env.api.post('pharmacy/calendarChanges', calendarChange);
    });

    const getByIdWithDetails = flow(function*(pharmacyId: number) {
      const result = yield env.api.get(`pharmacy/${pharmacyId}`, {
        params: {
          pharmacyId: pharmacyId,
          view: PharmacyViews.DETAILED,
        },
      });

      self.putInStore([result!]);
      return self.dataList.filter((d) => d.pharmacyId === pharmacyId);
    });

    return {
      savePharmacyDetails,
      updatePharmacyGeoData,
      loadNeighboringPharmacies,
      loadGroupPharmacies,
      getMissingHolidays,
      saveCalendarChange,
      registerMembers,
      unregisterMembers,
      getByIdWithDetails,
    };
  });
